import { Popover, PopoverTrigger, PopoverContent } from "@/components/ui/popover";
import { Info } from "lucide-react";

export default function VestaInfo({ className = "" }) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          onClick={(e) => e.stopPropagation()}
          className={`inline-flex h-4 w-4 items-center justify-center rounded-full text-amber-500 transition-colors hover:text-amber-400 focus:outline-none ${className}`}
          aria-label="Cosa sono i punti Vesta"
          data-testid="vesta-info-trigger"
        >
          <Info className="h-3.5 w-3.5" />
        </button>
      </PopoverTrigger>
      <PopoverContent align="start" className="w-80 text-left" data-testid="vesta-info-popover">
        <div className="space-y-3 text-sm leading-relaxed">
          <div className="font-heading text-base font-black text-[#E3B341]">Punti Vesta</div>
          <p>
            I punti Vesta sono il sistema di valore dedicato ai Partner della Rete Beyond.
          </p>
          <p className="text-muted-foreground">
            Si accumulano attraverso gli acquisti di prodotti TORRI e possono essere incrementati
            grazie a iniziative, obiettivi e attività speciali dedicate alla rete. Ogni punto Vesta
            ha un valore definito e può essere utilizzato per accedere ad attività di co-marketing,
            servizi, strumenti, esperienze e vantaggi riservati ai Partner.
          </p>
          <p className="text-muted-foreground">
            Il nome Vesta richiama una delle radici più antiche della cultura italiana: il fuoco
            custodito, simbolo di continuità, appartenenza e comunità. Un significato che abbiamo
            scelto per rappresentare una rete di professionisti e imprese che custodiscono il valore
            della tecnologia e del saper fare italiano.
          </p>
        </div>
      </PopoverContent>
    </Popover>
  );
}
